import { useCallback, useEffect, useState } from 'react';

import { useHasValidNylasAccount } from '@modules/_shared/hooks/useHasValidNylasAccount';
import { useAppData } from '@modules/_shared/providers/AppDataProvider';

export const useEmailConnectedRefresh = () => {
  const { refetchMe } = useAppData();
  const hasValidNylasAccount = useHasValidNylasAccount();
  const [connectSettled, setConnectSettled] = useState(false);

  // Contract: after the OAuth popup reports success we re-read `me`, then
  // reload only if the account is still invalid. The decision is made on the
  // render after `refetchMe` settles, because the refreshed `me` is not
  // committed yet when the promise continuation runs, and the read can resolve
  // before the new login row is visible. The flag is consumed on its first
  // evaluation, so a later disconnect announced from another tab never reloads
  // the page under a user who did nothing.
  useEffect(() => {
    if (!connectSettled) {
      return;
    }
    setConnectSettled(false);
    if (!hasValidNylasAccount) {
      window.location.reload();
    }
  }, [connectSettled, hasValidNylasAccount]);

  return useCallback(() => {
    refetchMe()
      .catch(() => {})
      .finally(() => setConnectSettled(true));
  }, [refetchMe]);
};
